import * as React from "react";

import type {ApolloGqlClient} from "./types.ts";

interface ApolloRouterContextData {
    /**
     * The ApolloGqlClient to use for Apollo-based GQL operations.
     */
    client: ApolloGqlClient | null | undefined;
}

export const ApolloRouterContext: React.Context<ApolloRouterContextData> =
    React.createContext<ApolloRouterContextData>({
        client: null,
    });
ApolloRouterContext.displayName = "ApolloRouterContext";
